import { useRef } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import ProfileCard from './ProfileCard';
import { Reveal } from './UI';

export default function Carousel({ title, sub, items = [], to, compact }) {
  const ref = useRef(null);
  if (!items.length) return null;
  const scroll = (dir) => ref.current?.scrollBy({ left: dir * ref.current.clientWidth * 0.8, behavior: 'smooth' });
  return (
    <section className="carousel">
      <Reveal className="carousel__head">
        <div>
          <h2>{title}</h2>
          {sub && <p className="muted">{sub}</p>}
        </div>
        <div className="carousel__ctrl">
          {to && <Link to={to} className="link">See all</Link>}
          <button className="icon-btn" onClick={() => scroll(-1)} aria-label="Previous"><Icon name="chevronLeft" /></button>
          <button className="icon-btn" onClick={() => scroll(1)} aria-label="Next"><Icon name="chevronRight" /></button>
        </div>
      </Reveal>
      <motion.div
        ref={ref}
        className="carousel__track"
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: '-40px' }}
        variants={{ hidden: {}, show: { transition: { staggerChildren: 0.07 } } }}
      >
        {items.map((p) => (
          <div className="carousel__slide" key={p.profileId}>
            <ProfileCard p={p} compact={compact} />
          </div>
        ))}
      </motion.div>
    </section>
  );
}
